<template>
  <section>
   
    <!-- Confirmation -->
    <!-- <div
      class="modal fade"
      id="modal-confirmation"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="getSchedule"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">
              Konfirmasi Pengajuan Vaksinasi
            </h5>
          </div>
          <div class="modal-body">
            Pasien {{ getSchedule.Patients.first_name }}
            {{ getSchedule.Patients.last_name }} ini mengajukan untuk melakukan
            vaksinasi vaksin {{ getSchedule.Vaccine.name }} pada tanggal
            {{ getSchedule.date }}. Setuju?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Tolak
            </button>
            <button
              @click="confirmation"
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Setujui
            </button>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Complete -->
    <!-- <div
      class="modal fade"
      id="modal-complete"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">
              Konfirmasi Selesai Vaksinasi
            </h5>
          </div>
          <div class="modal-body">
            Pasien {{ getSchedule.Patients.first_name }}
            {{ getSchedule.Patients.last_name }} sudah melakukan vaksinasi
            vaksin {{ getSchedule.Vaccine.name }} pada tanggal
            {{ getSchedule.date }}. Klik Benar jika vaksinasi sudah selesai
            dilakukan.
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Tutup
            </button>
            <button
              @click="complete"
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Benar
            </button>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Delete -->
    <!-- <div
      class="modal fade"
      id="modal-delete"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="staticBackdropLabel">
              Konfirmasi Pembatalan
            </h5>
          </div>
          <div class="modal-body">
            Pasien {{ getSchedule.Patients.first_name }}
            {{ getSchedule.Patients.last_name }} mengajukan pembatalan vaksinasi
            vaksin {{ getSchedule.Vaccine.name }} di tanggal
            {{ getSchedule.date }}. Klik Setujui Pembatalan untuk menghapus
            pasien dari list.
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Tutup
            </button>
            <button
              @click="deletion"
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Setujui Pembatalan
            </button>
          </div>
        </div>
      </div>
    </div> -->
  </section>
</template>

<script>
export default {
  name: "Modal",
  data: function () {
    return {
      username: "",
      email: "",
      password: "",
      // getSchedule : this.sched
    };
  },
  props: ['getSchedule'],
  computed: {
    getPuskesmasId() {
      return this.$route.params.id;
    }
    // getSchedule() {
    //   return this.$store.state.schedule;
    // },
  },
  methods: {
    submitAdmin() {
      console.log("masuk submit modal biasa");
      const admin = {
        username: this.username,
        email: this.email,
        password: this.password,
        puskesmas_id: this.getPuskesmasId,
      };
      console.log("sampe sini");
      this.$store.commit("POSTADMIN", admin);
      this.$store
        .dispatch("postAdmin")
        .then((response) => {
          console.log(response);
          const puskesmasId = this.getPuskesmasId;
          if (puskesmasId) {
            this.$store.dispatch("fetchPuskesmasDetail");
            this.username = "";
            this.email = "";
            this.password = "";
          } else {
            this.$store.dispatch("fetchPuskesmas");
            this.username = "";
            this.email = "";
            this.password = "";
          }
        })
        .catch((err) => {
          console.log(err.response.data.message);
        });
    },

    confirmation() {
      const scheduleId = this.getSchedule.id;
      console.log("asup confirmation");
      this.$store.commit("PATCHSTATUS", {
        status: "dikonfirmasi",
        scheduleId: scheduleId,
      });
      this.$store
        .dispatch("patchUser")
        .then((response) => {
          console.log(response);
          this.$store.dispatch("fetchPuskesmasDetail");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    complete() {
      const scheduleId = this.getSchedule.id;
      this.$store.commit("PATCHSTATUS", {
        status: "selesai",
        scheduleId: scheduleId,
      });
      this.$store
        .dispatch("patchUser")
        .then((response) => {
          console.log(response);
          this.$store.dispatch("fetchPuskesmasDetail");
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deletion() {
      console.log('masuk delete modal');
      const scheduleId = this.getSchedule.id;
      this.$store.commit("PATCHSTATUS", {
        status: "deletecomplete",
        scheduleId: scheduleId,
      });
      this.$store
        .dispatch("deleteSchedule")
        .then((response) => {
          console.log('masuk');
          console.log(response);
          this.$store.dispatch("fetchPuskesmasDetail");
        })
        .catch((err) => {
          console.log('masuk catch delete');
          console.log(err.response.data);
        });
    },
  },
};
</script>

<style></style>
